import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: theme.spacing(9),
    paddingRight: theme.spacing(16.25),
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.lighter,
        boxShadow: theme.shadows[2],
        zIndex: theme.zIndex.mobileStepper,
      },
    },
  },
  isChecked: {
    backgroundColor: `${theme.palette.primary.lighter} !important`,
  },
  itemIcon: {
    minWidth: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(7),
    },
  },
  itemCheckbox: {
    [theme.breakpoints.up('sm')]: {
      margin: 0,
    },
  },
  itemText: {
    color: theme.palette.primary.main,
  },
  itemActions: {
    zIndex: theme.zIndex.speedDial,
  },
}))

export default useStyles
